(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiptap-experience"] && !Shopify.designMode) return;
  try {
    
(function () {
  const phrases = [
    { text: 'audacious', hold: 3000 },
    { text: 'curious', hold: 2300 },
    { text: 'a hero', hold: 2700 },
    { text: 'audacious', hold: 0, terminal: true }
  ];
  const typeDelay = 105;
  const eraseDelay = 60;
  const betweenDelay = 180;
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cycleState = window.__TipTapHeroOneCycle || (window.__TipTapHeroOneCycle = { started: false, finished: false });

  function initRotator(root) {
    if (!root || root.dataset.rotatorReady === 'true') return;
    const phraseNode = root.querySelector('[data-tt-hero-phrase]');
    const unit = root.querySelector('[data-tt-hero-unit]');
    if (!phraseNode || !unit) return;

    root.dataset.rotatorReady = 'true';
    let timer = null;
    let phraseIndex = 0;
    let charIndex = phrases[0].text.length;
    let mode = 'hold';
    let finished = false;

    function clearTimer() {
      if (timer !== null) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function renderPrimary() {
      clearTimer();
      phraseIndex = 0;
      charIndex = phrases[0].text.length;
      mode = 'hold';
      phraseNode.textContent = phrases[0].text;
      unit.dataset.complete = 'true';
    }

    function finishPrimary() {
      clearTimer();
      phraseIndex = phrases.length - 1;
      charIndex = phrases[phraseIndex].text.length;
      mode = 'done';
      phraseNode.textContent = phrases[phraseIndex].text;
      unit.dataset.complete = 'true';
      finished = true;
      cycleState.finished = true;
      root.dataset.rotatorFinished = 'true';
    }

    function schedule(delay) {
      if (finished || cycleState.finished) return;
      clearTimer();
      timer = window.setTimeout(function () {
        timer = null;
        step();
      }, delay);
    }

    function step() {
      if (finished || cycleState.finished) return;
      if (motionQuery.matches) {
        finishPrimary();
        return;
      }

      const current = phrases[phraseIndex];

      if (mode === 'hold') {
        unit.dataset.complete = 'false';
        mode = 'erase';
        schedule(eraseDelay);
        return;
      }

      if (mode === 'erase') {
        if (charIndex > 0) {
          charIndex -= 1;
          phraseNode.textContent = current.text.slice(0, charIndex);
          schedule(eraseDelay);
          return;
        }
        phraseIndex += 1;
        charIndex = 0;
        mode = 'type';
        schedule(betweenDelay);
        return;
      }

      const next = phrases[phraseIndex];
      if (charIndex < next.text.length) {
        charIndex += 1;
        phraseNode.textContent = next.text.slice(0, charIndex);
        schedule(typeDelay);
        return;
      }

      unit.dataset.complete = 'true';
      if (next.terminal) {
        finishPrimary();
        return;
      }

      mode = 'hold';
      schedule(next.hold);
    }

    function start() {
      if (cycleState.finished || cycleState.started) {
        finishPrimary();
        return;
      }
      cycleState.started = true;
      renderPrimary();
      if (motionQuery.matches) {
        finishPrimary();
        return;
      }
      schedule(phrases[0].hold);
    }

    function handleMotionChange() {
      if (finished || cycleState.finished) return;
      if (motionQuery.matches) finishPrimary();
    }

    root.__ttHeroFinish = finishPrimary;

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', handleMotionChange);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(handleMotionChange);
    }

    start();
  }

  function boot() {
    document.querySelectorAll('[data-tt-hero-rotator]').forEach(initRotator);
  }

  function stopUnloadedSection(event) {
    const target = event.target;
    if (!target) return;
    const root = target.matches && target.matches('[data-tt-hero-rotator]')
      ? target
      : target.querySelector && target.querySelector('[data-tt-hero-rotator]');
    if (root && typeof root.__ttHeroFinish === 'function') root.__ttHeroFinish();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', stopUnloadedSection);
})();

  } catch(e) { console.error(e); }
})();
})();
